import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Particles } from "./p11shared";
import { useP11Lang } from "./p11lang";

export default function P11Verify() {
  const nav = useNavigate();
  const { lang, tt } = useP11Lang();
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";

  const submit = async () => {
    if (password.length < 8 || password !== password2) {
      toast.error(password.length < 8 ? "Minimaal 8 tekens" : "Wachtwoorden komen niet overeen");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/project11/auth/verify", { token, password });
      if (data.status === "password_reset") {
        toast.success(lang === "nl" ? "Nieuw wachtwoord ingesteld — log in" : "New password set — log in");
        nav("/project11/login", { replace: true });
        return;
      }
      localStorage.setItem("p11_token", data.token);
      if (data.status === "confirmed") nav("/project11/welcome", { replace: true });
      else nav("/project11/dashboard", { replace: true }); // pending_approval / waitlisted → dashboard toont juiste staat
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Verificatie mislukt");
    } finally { setBusy(false); }
  };

  if (!token) {
    return (
      <div className="p11-root relative">
        <Particles density={30} />
        <main className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 text-center">
          <div className="p11-label-yellow">PROJECT 11*</div>
          <p className="mt-6 text-sm" style={{ color: "#858585" }} data-testid="p11-verify-invalid">Ongeldige verificatielink.</p>
        </main>
      </div>
    );
  }

  return (
    <div className="p11-root relative" data-testid="p11-verify">
      <Particles density={40} />
      <div className="relative z-10 min-h-screen flex flex-col max-w-md mx-auto px-6 py-10">
        <div className="p11-label-yellow text-center">PROJECT 11* / VERIFICATIE</div>
        <main className="flex-1 flex flex-col justify-center">
          <h1 className="p11-h2 text-3xl mb-10">{tt("choose_password")}</h1>
          <div className="space-y-7">
            <div>
              <label className="p11-label">{tt("password")}</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" className="p11-input mt-1" data-testid="p11-verify-password" />
            </div>
            <div>
              <label className="p11-label">{tt("password2")}</label>
              <input type="password" value={password2} onChange={(e) => setPassword2(e.target.value)} autoComplete="new-password" onKeyDown={(e) => e.key === "Enter" && submit()} className="p11-input mt-1" data-testid="p11-verify-password2" />
            </div>
            <button onClick={submit} disabled={busy} className="p11-btn w-full" data-testid="p11-verify-submit">{busy ? "…" : tt("verify_btn")}</button>
          </div>
        </main>
      </div>
    </div>
  );
}
